// Palette for the ePocus product — a separate app served from the /epocus route subtree and
// wrapped in its own EpocusThemeProvider. This is intentionally NOT part of the main app's design
// system (src/components/ + src/global-providers/mui-provider/). Don't import it into the main app,
// and don't add general-purpose colours here.

// Write font sizes in px, get accessible rem values.
// Requires html { font-size: 100% } (set by EpocusThemeProvider).
export const rem = (px: number) => `${px / 16}rem`;

// Primary CTA colour — aligns with PALETTE.primary.main from the wider app.
export const EPOCUS_PRIMARY = "#004F71";
// Hover/pressed state for primary interactive elements
export const EPOCUS_PRIMARY_DARK = "#00425F";
// Selected/tint background for primary-tinted interactive elements (exam tiles, option rows)
export const EPOCUS_SELECTED_BG = "#eef3f6";
// Subtle hover background for primary-tinted interactive elements
export const EPOCUS_PRIMARY_HOVER_BG = "rgba(0,79,113,0.04)";

// Active icon colour — PALETTE.brand.main, used for selected/active icon tinting.
export const EPOCUS_ICON_ACTIVE = "#00A0AF";

/** @deprecated Use EPOCUS_PRIMARY or EPOCUS_ICON_ACTIVE instead. */
export const EPOCUS_TEAL = "#0d9488";
/** @deprecated Use EPOCUS_PRIMARY_DARK instead. */
export const EPOCUS_TEAL_DARK = "#0b7a72";
export const EPOCUS_BG = "#f0faf9";
export const EPOCUS_BORDER = "#e5e7eb";
export const EPOCUS_INACTIVE = "#9ca3af";
export const EPOCUS_WHITE = "#ffffff";
export const EPOCUS_TEXT_PRIMARY = "#111827";
export const EPOCUS_TEXT_SECONDARY = "#6b7280";

// Status badge colours
export const EPOCUS_STATUS_DRAFT_BG = "#fef3c7";
export const EPOCUS_STATUS_DRAFT_TEXT = "#92400e";
export const EPOCUS_STATUS_PENDING_BG = "#ccfbf1";
export const EPOCUS_STATUS_PENDING_TEXT = "#0f766e";
export const EPOCUS_STATUS_REVIEWED_BG = "#dcfce7";
export const EPOCUS_STATUS_REVIEWED_TEXT = "#166534";
export const EPOCUS_STATUS_COMPLETE_BG = "#f1f5f9";
export const EPOCUS_STATUS_COMPLETE_TEXT = "#475569";
export const EPOCUS_STATUS_IMPORTED_BG = "#fef9c3";
export const EPOCUS_STATUS_IMPORTED_TEXT = "#854d0e";

export const EPOCUS_PANEL_SCOPED_BORDER = "#a3d5da";
export const EPOCUS_PANEL_SCOPED_HEADER_BG = "#e3f1f2";
export const EPOCUS_PANEL_MUTED_BG = "#f6f8fa";
export const EPOCUS_PANEL_MUTED_BORDER = "#c9d4dd";

// To Document card
export const EPOCUS_TO_DOC_BG = "#fffbeb";
export const EPOCUS_TO_DOC_BORDER = "#fde68a";
export const EPOCUS_ORANGE = "#f97316";
export const EPOCUS_ORANGE_HOVER = "#ea6c05";

// Synced badge
export const EPOCUS_SYNCED_BG = "#dcfce7";
export const EPOCUS_SYNCED_TEXT = "#166534";

export const EPOCUS_NAVY = "#1e3a5f";
